import { translation, langKey } from '../translations/de'
import { ConceptConfiguration, ConceptDataCluster } from '../types/Survey/Analysis/Concept'

export type DefaultState = {
  TRANSLATION: { [key: string]: any }
  CURRENTLANG: String
  SURVEY_ANALYSIS_CONCEPT_CONFIGURATION: ConceptConfiguration | null
  SURVEY_ANALYSIS_CONCEPT_DATA_CLUSTER: ConceptDataCluster | null
  ENABLE_SCREENSHOT_MODE: boolean
}

const defaultState: DefaultState = {
  TRANSLATION: translation,
  CURRENTLANG: langKey,
  SURVEY_ANALYSIS_CONCEPT_CONFIGURATION: null,
  SURVEY_ANALYSIS_CONCEPT_DATA_CLUSTER: null,
  ENABLE_SCREENSHOT_MODE: false,
}

export default defaultState
